class CollectionFacets extends HTMLElement {
	constructor() {
		super();
		this.details = this.querySelectorAll("[js-dropdown-details]");
		this.initEvents();
	}

	initEvents() {
		this.details.forEach((detail) => {
			detail.addEventListener("click", (event) =>
				this.toggleDetail(event, detail)
			);
		});

		document.addEventListener("click", (event) =>
			this.handleClickOutside(event)
		);
	}

	toggleDetail(event, selectedDetail) {
		event.stopPropagation();

		const isOpen = selectedDetail.hasAttribute("open");
		this.details.forEach((detail) => detail.removeAttribute("open"));

		if (!isOpen) {
			selectedDetail.setAttribute("open", "");
		}
	}

	handleClickOutside(event) {
		if (!event.target.hasAttribute("js-dropdown-details")) {
			this.details.forEach((detail) => detail.removeAttribute("open"));
		}
	}
}

customElements.define("collection-facets", CollectionFacets);

class ColorFilter extends HTMLElement {
	constructor() {
		super();

		this.init();
		document.addEventListener(
			"color-filter-slider:init",
			this.initSlider.bind(this)
		);
	}

	init() {
		this.facetFiltersForm = document.querySelector("[js-facet-filters-form]");
		this.filterItems = this.querySelectorAll("[js-filter-color-item]");

		this.filterItems.forEach((filterItem) =>
			filterItem.addEventListener("click", this.handleColorFilter.bind(this))
		);
		this.initSlider();
	}

	handleColorFilter({ currentTarget }) {
		const filterForm = document.querySelector("[js-facet-filters-form]");
		const value = currentTarget.getAttribute("data-value");
		const inputField = document.querySelector(`input[value="${value}"]`);
		inputField.checked = true;

		if (filterForm?.getAttribute("is") === "lists-collection") {
			document.body.classList.add("is-filter-loading");
		}

		this.facetFiltersForm.dispatchEvent(new Event("input"));
	}

	initSlider() {
		new Swiper("[js-filter-slider]", {
			loop: false,
			grabCursor: false,
			spaceBetween: 0,
			slidesPerGroup: 1,
			slidesPerView: "auto",
			watchSlidesProgress: true,
			draggable: !0,
			autoHeight: !1,
			watchOverflow: !0,
			threshold: 10,
			mousewheel: {
				forceToAxis: !0,
			},
			observer: true,
			observeParents: true,
			freeMode: 1,
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			breakpoints: {
				0: {
					spaceBetween: 15,
				},
				990: {
					spaceBetween: 24,
				},
			},
		});
	}
}

customElements.define("color-filter", ColorFilter);

const params = new URLSearchParams(window.location.search);

const hasFilterOrSorting =
	[...params.keys()].some((key) => key.startsWith("filter.")) ||
	params.has("sort_by");

if (hasFilterOrSorting) {
	const facetForm = document.querySelector("[js-facet-filters-form]");

	if (facetForm?.getAttribute("is") === "lists-collection") {
		document.body.classList.add("is-filter-applied");
	}
}
